export default __webpack_public_path__ + "static/media/legal_2025.88cdcf60.jpg";